export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtSkladost';
export const NAME = 'SkladPredmetu';
